import { Input, InputProps } from 'components'

import { SearchIcon } from '../icons'

type SearchInputProps = Omit<InputProps, 'iconLeft'>

const SearchInput = (props: SearchInputProps) => <Input iconLeft={SearchIcon} {...props} />

export default SearchInput
